export function isWidgetReady(state) {
    return !!state.widgetizedState;
}
//# sourceMappingURL=invariants.js.map